import { useLocation } from "react-router-dom";
import { BugReportPage as SharedBugReportPage, type BugReportPageProps } from "@jkast90/kast-common/bug-report-form";
import { isSignedIn, useSession } from "@jkast90/kast-common/auth";
import { session, signIn } from "../auth/session";
import { useAdminMode } from "@common/adminMode";

/** CloudBoy's id in the kast-dev bug report inbox: its deploy and metadata prefix. */
const BUG_REPORT_APP = "cloudboy";

const CLASSES = {
  page: "about-main",
  section: "panel",
  button: "btn",
  primaryButton: "btn primary",
  input: "input",
  label: "field-label",
  hint: "muted small",
};

const HEAD = (
  <div className="library-head">
    <h1>Report a bug</h1>
  </div>
);

type Props = Pick<BugReportPageProps, "user" | "showLogs" | "onSignIn" | "initialDescription" | "navigationState">;

/**
 * The report page, with no router or store hooks, so the app-level crash
 * screen can show it outside the providers. Reports go to the kast-dev
 * admin inbox, not CloudBoy's API. The logs are shown beside the form to
 * admins with admin tools on.
 */
export function BugReport(props: Props) {
  return (
    <SharedBugReportPage
      app={BUG_REPORT_APP}
      getToken={() => session.bearer()}
      onUnauthorized={session.onUnauthorized}
      title={null}
      intro={HEAD}
      logsTitle="Attached logs"
      classNames={CLASSES}
      {...props}
    />
  );
}

/** /bug-report: pre-filled when arriving from a crash screen's Report This. */
export default function BugReportPage() {
  const { state } = useLocation();
  // Not `user`, which a session still loading already has.
  const auth = useSession();
  const user = isSignedIn(auth) ? auth.user : null;
  const { unlocked } = useAdminMode();
  return (
    <BugReport
      user={user ? { id: user.sub, email: user.email || null } : null}
      showLogs={unlocked}
      onSignIn={signIn}
      navigationState={state}
    />
  );
}
